import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';

import { Company } from '../../../types';
import {
  companyAdditionalOptions,
  companyStandartOptions,
} from '../../../constants/companies';

import { Text18 } from '../../../ui/Text18';

const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 50px;

  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

const OptionsHeaderTitle = styled(Text18)`
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 20px;
`;

const StandartOptions = styled.div`
  flex: 1;
`;
const AdditionalOptions = styled.div`
  flex: 1;
`;

const OptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 8px;
`;
const OptionTitle = styled(Text18)`
  color: ${({ theme }) => theme.colors.darkGray};
  max-width: 60%;
`;

const OptionAmount = styled(Text18)`
  color: ${({ theme }) => theme.colors.descriptionColor};
`;

const CheckBlock = styled(CheckIcon)`
  color: ${({ theme }) => theme.colors.green};  
  widht: 16px;
  height: 16px;
`;

const LineBlock = styled(RemoveIcon)`
  color: ${({ theme }) => theme.colors.darkGray};  
  widht: 16px;
  height: 16px;
`;

type Props = {
  company: Company;
}

const AdditionalInformation: React.FC<Props> = ({company}) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <StandartOptions>
        <OptionsHeaderTitle>{`${t('standard_options')}`}</OptionsHeaderTitle>
        {companyStandartOptions.map((option, index) => {
          return (
            <OptionWrapper key={index}>
              <OptionTitle>{  `${t(option.title)}`}</OptionTitle>
                {
                  <CheckBlock/>                 
                }            
            </OptionWrapper>
          );
        })}        
        <OptionWrapper>
          <OptionTitle>{`${t('emergency_dentistry')}`}</OptionTitle>
          {(company.name === "intact") ? <LineBlock/> : <OptionAmount>200 €</OptionAmount>}
        </OptionWrapper>
        <OptionWrapper>
          <OptionTitle>{`${t('phone_expenses')}`}</OptionTitle>
          {(company.name === "intact") ? <LineBlock/> : <CheckBlock/>}
        </OptionWrapper>
      </StandartOptions>
      <AdditionalOptions>
        <OptionsHeaderTitle>{`${t('standard_options')}`}</OptionsHeaderTitle>
        {companyAdditionalOptions.map((option, index) => {
          return (
            <OptionWrapper key={index}>
              <OptionTitle>{`${t(option.title)}`}</OptionTitle>
              {
                ((index === 1 && company.name === "intact") || index === 2) ? <LineBlock/> :  <CheckBlock/>                               
              }                    
            </OptionWrapper>
          );
        })}
        
        {
          (company.name === "donaris") && (
            <OptionWrapper >
              <OptionTitle>{`${t('expenses_for_person')}`}</OptionTitle>
              <OptionAmount>500 €</OptionAmount>
            </OptionWrapper>
          )          
        }
      </AdditionalOptions>
    </Wrapper>
  );
};

export default AdditionalInformation;
